module.exports = __webpack_public_path__ + "components/flag/static/square/ni-448a717927547c22689b6e54d5f0d6be.svg";